export default __webpack_public_path__ + "static/media/2.71ab7bdf.png";